import SVSubscriptionExpiredNotice from '@apps/www/src/www/components/SVSubscriptionExpiredNotice';
import SVGridContainer from '@apps/www/src/www/containers/SVGridContainer';
import SVRedirect from '@apps/www/src/www/containers/SVRedirect';
import SVWithUserPage, {
	type Props as SVWithUserPageProps,
} from '@apps/www/src/www/containers/SVWithUserPage';
import useAuthSubscriptionIsExpired from '@apps/www/src/www/hooks/useAuthSubscriptionIsExpired';
import usePersistentSetting, {
	PersistentSettingKeys,
} from '@apps/www/src/www/hooks/usePersistentSetting';
import useUserAndBoardPageQuery from '@apps/www/src/www/hooks/useUserAndBoardPageQuery';
import BoardItemsQuery from '@apps/www/src/www/queries/BoardItemsQuery';
import usePaginatedQuery from '@pkgs/shared-client/hooks/usePaginatedQuery';
import BoardUserRole from '@pkgs/shared/enums/BoardUserRole';
import FeedSourceType from '@pkgs/shared/enums/FeedSourceType';
import UpgradeButtonSource from '@pkgs/shared/enums/UpgradeButtonSource';
import boardUserRoleHasBoardUserRolePrivileges from '@pkgs/shared/helpers/boardUserRoleHasBoardUserRolePrivileges';
import { usePrevious } from 'react-use';

const _SVFeedUserBoardPage = ({ user, board }: SVWithUserPageProps) => {
	const [sortMethod] = usePersistentSetting(PersistentSettingKeys.ITEMS_SORT_METHOD);
	const { items, loading, paginate, isLimited } = usePaginatedQuery(BoardItemsQuery, {
		variables: { boardID: board?._id || '', sortMethod },
		skip: !board,
	});
	const previousBoardID = usePrevious(board?._id);
	const expiredSubscriptionData = useAuthSubscriptionIsExpired();
	const { isOwner } = useUserAndBoardPageQuery();

	if (!board) {
		if (previousBoardID) {
			const newBoard = user.boards.find((board) => board._id == previousBoardID);

			if (newBoard) {
				return <SVRedirect to={`${newBoard.url}`} replace={true} />;
			}
		}

		return <SVRedirect to={`${user.url}boards/`} replace={true} />;
	}

	//maybe here

	const hasEditorPrivileges = boardUserRoleHasBoardUserRolePrivileges(
		board.role,
		BoardUserRole.EDITOR,
	);

	const canSeeItems = !board.isPrivate || hasEditorPrivileges;

	if (expiredSubscriptionData && !isOwner) {
		return (
			<SVSubscriptionExpiredNotice
				source={UpgradeButtonSource.BLOCKED_BOARDS_USERS}
				expiredMessageType={expiredSubscriptionData.expiredMessageType}
			/>
		);
	}

	return (
		<>
			{canSeeItems && (
				<div className="w-full">
					<SVGridContainer
						sourceType={FeedSourceType.BOARD}
						items={items}
						isLoading={loading}
						onPaginate={paginate}
						isLimited={isLimited}
					/>
				</div>
			)}
		</>
	);
};

const SVFeedUserBoardPage = SVWithUserPage(_SVFeedUserBoardPage);

// @ts-ignore fix
SVFeedUserBoardPage.withUserHeader = false;
// @ts-ignore fix
SVFeedUserBoardPage.withBoardHeader = true;
// @ts-ignore fix this
SVFeedUserBoardPage.withUserSideMenu = true;

export default SVFeedUserBoardPage;
